import React, { Component, createRef } from 'react';

import classNames from 'clsx';

import { Box, Typography, alpha } from '@mui/material';

import { formatDateDay, formatDateDayShortDayName, formatDateISO } from '~/services/TimeService';

interface DayData {
  day?: Date;
  availability?: { count: number; total: number };
  blackout?: boolean;
  surcharge?: unknown;
  surchargeLabel?: string;
}

interface DayProps {
  dayDate: DayData;
  idx: number;
}

interface DayState {
  selected: boolean;
}

export default class InventoryCalendarDay extends Component<DayProps, DayState> {
  element: React.RefObject<HTMLDivElement>;
  // Read by Selection's rangeCompareFunc (dayCompareFunc), which compares day refs by `.date`.
  date: Date | undefined;
  constructor(props: DayProps) {
    super(props);

    this.state = {
      selected: false,
    };
    this.element = createRef<HTMLDivElement>();
    this.date = props.dayDate.day;
  }

  setSelected(selected: boolean) {
    this.setState({ selected });
  }

  getDOMNode() {
    return this.element?.current;
  }

  render() {
    const { dayDate, idx } = this.props;
    const { selected } = this.state;
    const dayClasses = dayDate.day
      ? [`day-${formatDateISO(dayDate.day)}`, `day-${formatDateDayShortDayName(dayDate.day).toLowerCase()}`]
      : null;

    const classes = classNames('availability-day', dayClasses, {
      'select-box': !!dayDate.day,
      blackout: dayDate.blackout,
      surcharge: dayDate.surcharge,
      selected,
    });

    return (
      <Box
        className={classes}
        key={idx}
        ref={this.element}
        sx={[
          dayDate.surcharge && {
            borderLeft: '3px solid',
            borderLeftColor: 'warning.light',
            bgcolor: (theme) => alpha(theme.palette.warning.light, 0.3),
          },
          dayDate.blackout && {
            bgcolor: 'grey.100',
            backgroundImage: (theme) =>
              `repeating-linear-gradient(-45deg, ${theme.palette.grey[300]}, ${theme.palette.grey[300]} 4px, transparent 4px, transparent 10px)`,
          },
        ]}
      >
        {dayDate.day && (
          <Box className="date" sx={{ color: dayDate.blackout ? 'text.disabled' : undefined }}>
            {formatDateDay(dayDate.day)}
            {dayDate.surcharge && (
              <Box component="sup" sx={{ color: 'warning.main' }}>
                {' '}
                +
              </Box>
            )}
          </Box>
        )}
        {dayDate.availability && (
          <Box className="counts" sx={{ color: dayDate.blackout ? 'text.disabled' : undefined }}>
            {dayDate.availability.count} / {dayDate.availability.total}
          </Box>
        )}
        {dayDate.surchargeLabel && (
          <Typography variant="caption" color="warning.main" fontWeight="bold">
            {dayDate.surchargeLabel}
          </Typography>
        )}
      </Box>
    );
  }
}
